class ABTesting {

  get sdk() {
    return (process.env.VUE_APP_CONTEXT == 'WEB' ? window.googleOptimise : null) || {}
  }

  getValue(name) {
    return this.sdk[name]
  }
}

export default new ABTesting()